// Cross-page badge counts (live pending approvals, etc).
// Pages call `refreshApprovalsCount()` after mutations; SideNav subscribes
// and polls every 15s as a safety net.

import { create } from "zustand";
import { api } from "@/lib/api";

interface BadgeState {
  approvalsPending: number;
  lastFetchedAt: number;
  refreshApprovalsCount: () => Promise<void>;
}

export const useBadgeStore = create<BadgeState>((set) => ({
  approvalsPending: 0,
  lastFetchedAt: 0,
  refreshApprovalsCount: async () => {
    try {
      const { count } = await api.approvals.pendingCount();
      set({ approvalsPending: count, lastFetchedAt: Date.now() });
    } catch {
      // swallow; keep last known value
    }
  },
}));

export function refreshApprovalsCount() {
  return useBadgeStore.getState().refreshApprovalsCount();
}
